import React from "react";
import "../css/dashboard.css";

import CasadaSwitch from "../component/CasadaSwitch";

export default function RoomLayoutContent() {

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Tutorials",
  //       "pageLoad",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);

  return (
    <div className="right-container">
      <CasadaSwitch title={"Room Layout"} />{" "}
      {/* Utilisation du nouveau composant */}
    </div>
  );
}
